export class Produit {
  nom: string = "";
  unite_mesure_id: string = "";
  etat_produit_id: string = "";
  categorie_produit_id: string = "";
  variete_produit_id: string = "";
  image: any = "";

  private errorMessage: string;

  constructor() {
    this.errorMessage = "";
  }

  // Récupérer le message d'erreur
  getErrorMessage(): string {
    return this.errorMessage;
  }

  // Vérifier si on peut sauvegarder
  canSave(): boolean {
    // Vérification du nom
    if (!this.nom || this.nom.trim() === "") {
      this.errorMessage = "Veuillez saisir le nom du produit";
      return false;
    }
    // Vérification de la catégorie du produit
    if (!this.categorie_produit_id ) {
      this.errorMessage = "Veuillez sélectionner la catégorie du produit";
      return false;
    }
    // Vérification de l'unité de mesure
    if (!this.unite_mesure_id ) {
      this.errorMessage = "Veuillez sélectionner l'unité de mesure";
      return false;
    }

    // Vérification de l'état du produit
    if (!this.etat_produit_id ) {
      this.errorMessage = "Veuillez sélectionner l'état du produit";
      return false;
    }

   

    // Vérification de la variété du produit
    if (!this.variete_produit_id ) {
      this.errorMessage = "Veuillez sélectionner la variété du produit";
      return false;
    }

    // Vérification de l'image
    if (!this.image) {
      this.errorMessage = "Veuillez télécharger une image du produit";
      return false;
    }

    // Si tous les champs sont valides
    this.errorMessage = ""; // Réinitialiser le message d'erreur
    return true;
  }
}
